
import axios from "axios";

export const API  =  axios.create({
   // baseURL: `http://127.0.0.1:8001/api`,
    baseURL: `https://hosapi.connexxiontelecom.com/api`,
});